import preReqTypes from "./preReq.types";

const INITIAL_STATE = {
  typeOfLoad: "",
  typeOfLoad_isLoading: false,

  submitPreReq: "",
  submit_isLoading: false,
  shown_support: null,
  response_new_instant_request: null,
};

const preReqReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case preReqTypes.RESPONSE_NEW_INSTANT_REQUEST:
      return {
        ...state,
        response_new_instant_request: action.payload,
      };
    case preReqTypes.FETCH_TYPE_OF_LOAD_SUCCESS:
      return {
        ...state,
        typeOfLoad: action.payload,
        typeOfLoad_isLoading: false,
      };
    case preReqTypes.FETCH_TYPE_OF_LOAD_START:
      return {
        ...state,
        typeOfLoad_isLoading: true,
      };

    case preReqTypes.SUBMIT_PREREQ_START:
      return {
        ...state,
        submit_isLoading: true,
      };
    case preReqTypes.SUBMIT_PREREQ_SUCCESS:
      return {
        ...state,
        submitPreReq: action.payload,
        submit_isLoading: false,
      };
    case preReqTypes.SET_SHOWN_SUPPORT:
      return {
        ...state,
        shown_support: action.payload,
      };

    default:
      return state;
  }
};

export default preReqReducer;
